namespace Areas.Reviewers {
    "use strict";


    export function view() {
        gotoSelected("ContractLinkListGrid", "/Reviewers/ContractLink/View/");
    }

    export function edit() {
        gotoSelected("ContractLinkListGrid", "/Reviewers/ContractLink/Edit/");
    }
    





    export function goToList() {
        var linkInfo = "/Reviewers/List/Index";
        location.href = linkInfo;
    }



}